/**
 * Merkezi helper: responseStructure değerinin LegOptionsList olup olmadığını kontrol eder.
 * One-way adapter "CombinableLegsList.LegOptionsList", round-trip/multi-city adapter "LegOptionsList" döner.
 * Tüm kod tabanında bu iki string'i tek fonksiyon ile yakalamak için kullanılır.
 */
export function isLegOptionsList(responseStructure) {
  return (
    responseStructure === "LegOptionsList" ||
    responseStructure === "CombinableLegsList.LegOptionsList"
  );
}
